<template>
  <ion-page>
    <master-layout pageTitle="ویرایش انبار">
      <ion-card>
        <ion-card-content>
          <Loading :is="!warehouseLoaded" v-if="!warehouseLoaded"></Loading>
          <div v-if="warehouseLoaded">
            <div v-if="warehouse">
              <AjaxForm route="warehouse/edit">
                <input class="" type="hidden" name="warehouse_id" :value="warehouse._id">
              <div class="mt-2">
                <label>عنوان</label>
                <input class="form-control" type="text" name="title" :value="warehouse.title">
              </div>
              <div class="mt-2">
                <label>توضیحات</label>
                <textarea class="form-control" name="description" :value="warehouse.description"></textarea>
              </div>
              <div class="mt-2">
                <label>استان</label>
                <select autocomplete="off" class="form-control" @change="apiGetCities($event)" name="state_id">
                  <option value="0" disabled selected>لطفا استان مورد نظر را انتخاب نمایید</option>
                  <option :key="state._id" :selected="(warehouse.state_id && state._id===warehouse.state_id)" v-for="state in states" :value="state._id">{{ state.title }}</option>
                </select>
              </div>
              <div class="mt-2">
                <label>شهر</label>
                <div class="city_div">
                  <select name="city_id" data-title="استان را انتخاب کنید" class="form-control">
                    <option :key="city._id" :selected="(warehouse.city_id && city._id===warehouse.city_id)" v-for="city in cities" :value="city._id">{{ city.title }}</option>
                  </select>
                </div>
              </div>
              <div class="mt-2">
                <label>تلفن ثابت</label>
                <input class="form-control" type="text" name="telephone" :value="warehouse.telephone">
              </div>
              <div class="mt-2">
                <label>آدرس</label>
                <textarea class="form-control" name="address" :value="warehouse.address"></textarea>
              </div>
              <div class="">
                <button class="btn btn-success btn-block btn-lg" type="submit">افزودن انبار</button>
              </div>
              </AjaxForm>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{error}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "@/components/Loading";
import AjaxForm from "@/components/AjaxForm";

export default {
  data()
  {
    return {
      id:null,
      warehouseLoaded: false,
      warehouse:null,
      cities:[],
      states:[],
      error:null
    };
  },
  async created()
  {
    this.id = this.$route.params.warehouseId;
    const result = await this.getWarehouse(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.warehouseLoaded = true;
        this.warehouse = result.warehouse;
        this.states = await this.getStates();
        if (this.warehouse.state_id)
        {
          const cities = await this.apiGetCities(this.warehouse.state_id);
          if (cities && cities.ok)
          {
            this.cities = cities.cities;
          }
        }
      }
      else
      {
        this.warehouseLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.warehouseLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  components: {
    Loading, AjaxForm,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    ...mapActions("warehouse", {
      getWarehouse: 'getWarehouse'
    }),
    ...mapActions('app',{
      getStates: 'getStates',
      apiGetCities: 'getCities',
    })
  }
};

</script>

<style scoped>

</style>